import React from "react"
import {
    Button,
    ButtonVariant,
    componentStyles,
    Text,
    useColors,
    useTheme,
    VerticalStack,
} from "@mallardbay/lib-react-components"

import type { AssistantConversation } from "~utils/helpers/outfitter-assistant-conversation-history-helpers"
import { getHumanReadableCreatedAt } from "~utils/helpers/date-helpers"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/constants"

export default function AssistantConversationHistoryItem({
    conversation,
    isDisabled,
    onSelect,
}: Props) {
    const styles = useStyles()
    const title =
        conversation.title ??
        conversation.last_message_preview ??
        COPY.OUTFITTER_ASSISTANT_HISTORY_UNTITLED
    const dateLabel = getHumanReadableCreatedAt(
        conversation.last_message_at ?? conversation.created_at
    )

    return (
        <Button
            variant={ButtonVariant.Unstyled}
            onClick={() => void onSelect(conversation)}
            isDisabled={isDisabled}
            style={styles.root}
            testId={TEST_IDS.OUTFITTER_ASSISTANT_HISTORY_ITEM}
        >
            <VerticalStack style={styles.text}>
                <Text style={styles.title}>{title}</Text>
                {dateLabel && <Text style={styles.date}>{dateLabel}</Text>}
            </VerticalStack>
        </Button>
    )
}

function useStyles() {
    const colors = useColors()
    const theme = useTheme()

    return componentStyles({
        root: {
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 3,
            width: "100%",
            minHeight: "64px",
            height: "auto",
            padding: 4,
            borderRadius: theme.radii.lg,
            backgroundColor: colors.bgSecondary,
            color: colors.text,
            textAlign: "left",
        },
        text: {
            alignItems: "flex-start",
            gap: 1,
            minWidth: 0,
        },
        title: {
            fontWeight: theme.fontWeights.medium,
            lineHeight: 1.35,
        },
        date: {
            color: colors.secondaryText,
            fontSize: theme.fontSizes.sm,
        },
    })
}

interface Props {
    readonly conversation: AssistantConversation
    readonly isDisabled: boolean
    readonly onSelect: (conversation: AssistantConversation) => Promise<void>
}
